import React, { useState } from 'react';
import I18N from '@leverege/i18n';
import { LoadingScreen } from '@leverege/molten/screens';
import { Dialog, Content, Pane, Text, Button } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import RecovrReconciliation from '../../util/RecovrReconciliation';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('recovr.locator.reconcile.SaleDialog');
export default function SaleDialog(props) {
  const {
    show,
    onClose,
    actions,
    sale
  } = props;
  const [loading, setLoading] = useState(false);
  const onOkay = async () => {
    setLoading(true);
    await RecovrReconciliation.reconcileSaleLocator({
      actions,
      onClose,
      sale
    });
    setLoading(false);
    onClose();
  };
  return /*#__PURE__*/_jsx(Dialog, {
    show: show,
    onClose: onClose,
    children: /*#__PURE__*/_jsxs(Content, {
      relative: true,
      children: [/*#__PURE__*/_jsx(Content.Header, {
        variant: "dialogHeader",
        children: /*#__PURE__*/_jsx(TitleBar, {
          variant: "dialogTitle",
          title: t('title'),
          icon: tIcon('titleIcon')
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        style: {
          minHeight: '120px'
        },
        variant: "dialogBody",
        children: loading ? /*#__PURE__*/_jsx(Pane, {
          children: /*#__PURE__*/_jsx(LoadingScreen, {
            title: t('loadingTitle')
          })
        }) : /*#__PURE__*/_jsx(Text, {
          variant: "body",
          children: t('enabledMessage')
        })
      }), /*#__PURE__*/_jsxs(Content.Footer, {
        variant: "dialogFooter",
        layout: "flex:rowMEnd",
        children: [/*#__PURE__*/_jsx(Button, {
          disabled: loading,
          variant: "secondary",
          onClick: onClose,
          children: t('cancel')
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onOkay,
          variant: "primary",
          disabled: loading,
          children: t('confirm')
        })]
      })]
    })
  });
}